import React, { useState } from "react";

function About() {
  const [activeTab, setActiveTab] = useState("frontend");

  const socialLinks = [
    {
      name: "YouTube",
      href: "https://www.youtube.com/@Haidar-hn6lt",
      svg: (
        <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
      )
    },
    {
      name: "Instagram",
      href: "https://www.instagram.com/muhammad_haidar_syihab/",
      svg: (
        <path d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405c0 .795-.646 1.44-1.44 1.44-.795 0-1.44-.646-1.44-1.44 0-.794.646-1.439 1.44-1.439.793-.001 1.44.645 1.44 1.439z" />
      )
    },
    {
      name: "Facebook",
      href: "https://www.facebook.com/MuhammadHaidarShahab.MuhammadHaidarShahab",
      svg: (
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
      )
    },
    {
      name: "LinkedIn",
      href: "https://www.linkedin.com/in/muhammad-haidar-shahab-504252287/",
      svg: (
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
      )
    }
  ];

  return (
    <section id="about" className="pt-36 pb-32 bg-slate-950 text-slate-100 relative overflow-hidden bg-cyber-grid">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-emerald-500/10 border border-emerald-500/30 text-emerald-400 font-mono text-xs font-bold uppercase tracking-widest mb-4">
            💻 SOFTWARE ENGINEERING &amp; DUAL COMPETENCY SPECS
          </div>
          <h2 className="text-3xl sm:text-5xl font-black tracking-tight text-white mb-4">
            Software Engineering &amp; <span className="text-emerald-400">Scalable Web Ecosystems</span>
          </h2>
          <p className="text-slate-300 text-base lg:text-lg leading-relaxed max-w-2xl mx-auto">
            Software Engineer specializing in responsive web applications and scalable front-end ecosystems. Experienced with <strong className="text-white">JavaScript (ES6+) and TypeScript</strong>, applying clean architecture principles, functional hooks, and predictable global state management (<strong className="text-emerald-400 font-mono">Redux &amp; Context API</strong>). Highly skilled in crafting pixel-perfect interfaces using <strong className="text-white">Tailwind CSS</strong>, with strong foundational engineering experience in version control workflows (<strong className="text-emerald-400 font-mono">Git, GitHub, GitLab</strong>) and backend integration (<strong className="text-white">PHP, Laravel, Go</strong>).
          </p>
        </div>

        <div className="flex flex-wrap -mx-4 items-stretch">
          {/* Left Column: Interactive Competency Tabs & Progress Gauges */}
          <div className="mb-10 w-full px-4 lg:w-7/12">
            <div className="cyber-card p-6 sm:p-8 rounded-3xl border border-emerald-500/30 bg-slate-900/80 backdrop-blur-md shadow-2xl h-full flex flex-col justify-between">
              <div>
                {/* Interactive Spec Tabs */}
                <div className="flex flex-wrap gap-2 mb-6 border-b border-slate-800 pb-4">
                  <button
                    type="button"
                    onClick={() => setActiveTab("frontend")}
                    className={`px-4 py-2 rounded-xl text-xs font-mono font-bold transition-all ${
                      activeTab === "frontend"
                        ? "bg-emerald-500 text-slate-950 shadow-md shadow-emerald-500/30"
                        : "bg-slate-950 text-slate-400 hover:text-white"
                    }`}
                  >
                    💻 Frontend &amp; Modern Web
                  </button>
                  <button
                    type="button"
                    onClick={() => setActiveTab("backend")}
                    className={`px-4 py-2 rounded-xl text-xs font-mono font-bold transition-all ${
                      activeTab === "backend"
                        ? "bg-indigo-500 text-white shadow-md shadow-indigo-500/30"
                        : "bg-slate-950 text-slate-400 hover:text-white"
                    }`}
                  >
                    ⚙️ Backend &amp; Microservices
                  </button>
                  <button
                    type="button"
                    onClick={() => setActiveTab("ai")}
                    className={`px-4 py-2 rounded-xl text-xs font-mono font-bold transition-all ${
                      activeTab === "ai"
                        ? "bg-teal-400 text-slate-950 shadow-md shadow-teal-400/30"
                        : "bg-slate-950 text-slate-400 hover:text-white"
                    }`}
                  >
                    🤖 AI Agents &amp; Systems
                  </button>
                </div>

                {/* Tab Content Display */}
                {activeTab === "frontend" && (
                  <div className="flex flex-col gap-4 animate-fade-in font-mono text-xs text-slate-300">
                    <p className="text-emerald-400 font-bold text-sm">
                      [ FRONTEND, NEXT.JS 16, REACT 19 &amp; TYPESCRIPT ]
                    </p>
                    <p className="leading-relaxed">
                      Specialized in building high-performance reactive web applications, responsive enterprise user interfaces, and Progressive Web Apps using <strong>TypeScript, React 19, Next.js 16, Tailwind CSS</strong>, and modern state management.
                    </p>
                    <div className="space-y-3 pt-2">
                      <div>
                        <div className="flex justify-between mb-1 font-bold text-[11px]">
                          <span>TypeScript &amp; React / Next.js Architecture</span>
                          <span className="text-emerald-400">99%</span>
                        </div>
                        <div className="w-full bg-slate-950 rounded-full h-2 border border-slate-800">
                          <div className="bg-emerald-500 h-2 rounded-full w-[99%]" />
                        </div>
                      </div>
                      <div>
                        <div className="flex justify-between mb-1 font-bold text-[11px]">
                          <span>Tailwind CSS &amp; Modern UI/UX Ergonomics</span>
                          <span className="text-emerald-400">98%</span>
                        </div>
                        <div className="w-full bg-slate-950 rounded-full h-2 border border-slate-800">
                          <div className="bg-emerald-400 h-2 rounded-full w-[98%]" />
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {activeTab === "backend" && (
                  <div className="flex flex-col gap-4 animate-fade-in font-mono text-xs text-slate-300">
                    <p className="text-indigo-400 font-bold text-sm">
                      [ BACKEND MICROSERVICES, NODE.JS, NESTJS, LARAVEL &amp; QUARKUS ]
                    </p>
                    <p className="leading-relaxed">
                      Expert in designing high-throughput REST/GraphQL APIs, distributed BPMN workflow microservices, and RDBMS/NoSQL data pipelines (<strong className="text-white">Node.js, NestJS, Laravel, Java Quarkus, PostgreSQL, Redis</strong>).
                    </p>
                    <div className="space-y-3 pt-2">
                      <div>
                        <div className="flex justify-between mb-1 font-bold text-[11px]">
                          <span>Node.js / NestJS / Laravel / Java Quarkus Backend</span>
                          <span className="text-indigo-400">97%</span>
                        </div>
                        <div className="w-full bg-slate-950 rounded-full h-2 border border-slate-800">
                          <div className="bg-indigo-500 h-2 rounded-full w-[97%]" />
                        </div>
                      </div>
                      <div>
                        <div className="flex justify-between mb-1 font-bold text-[11px]">
                          <span>Database Architecture &amp; High-Throughput APIs</span>
                          <span className="text-indigo-400">95%</span>
                        </div>
                        <div className="w-full bg-slate-950 rounded-full h-2 border border-slate-800">
                          <div className="bg-indigo-400 h-2 rounded-full w-[95%]" />
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {activeTab === "ai" && (
                  <div className="flex flex-col gap-4 animate-fade-in font-mono text-xs text-slate-300">
                    <p className="text-teal-300 font-bold text-sm">
                      [ STEALTH AI AGENTS, ELECTRON OVERLAYS &amp; AUTOMATION ]
                    </p>
                    <p className="leading-relaxed">
                      Creator of <strong>My Agent — Autonomous Career &amp; Personal Brand OS</strong>. Architected stealth desktop overlay applications using Electron, Puppeteer ATS auto-tailoring, and multi-key load balancer failovers.
                    </p>
                    <div className="space-y-3 pt-2">
                      <div>
                        <div className="flex justify-between mb-1 font-bold text-[11px]">
                          <span>Stealth AI Agents &amp; Electron Desktop Overlays</span>
                          <span className="text-teal-300">96%</span>
                        </div>
                        <div className="w-full bg-slate-950 rounded-full h-2 border border-slate-800">
                          <div className="bg-teal-400 h-2 rounded-full w-[96%]" />
                        </div>
                      </div>
                      <div>
                        <div className="flex justify-between mb-1 font-bold text-[11px]">
                          <span>Puppeteer Web Automation &amp; ATS Tailoring</span>
                          <span className="text-teal-300">95%</span>
                        </div>
                        <div className="w-full bg-slate-950 rounded-full h-2 border border-slate-800">
                          <div className="bg-teal-300 h-2 rounded-full w-[95%]" />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Right Column: Social Channels */}
          <div className="w-full px-4 lg:w-5/12">
            <div className="cyber-card p-6 sm:p-8 rounded-3xl border border-indigo-500/30 bg-slate-900/80 backdrop-blur-md shadow-2xl h-full flex flex-col justify-between">
              <div>
                <h3 className="mb-4 text-2xl font-black text-white font-mono">
                  📡 Developer Channels &amp; Network
                </h3>
                <p className="mb-8 text-sm font-normal text-slate-300 leading-relaxed">
                  Connect across professional software engineering channels to review code repositories, discuss full-stack microservices architecture, or explore AI agent opportunities:
                </p>
                
                <div className="flex flex-wrap gap-4 items-center">
                  {socialLinks.map((social) => (
                    <a
                      key={social.name}
                      href={social.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={social.name}
                      className="flex h-14 w-14 items-center justify-center rounded-2xl border border-emerald-500/30 bg-slate-950 text-emerald-400 transition-all duration-300 hover:border-emerald-400 hover:bg-emerald-500 hover:text-slate-950 hover:scale-110 shadow-lg shadow-emerald-500/10"
                    >
                      <svg
                        role="img"
                        width="24"
                        className="fill-current"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <title>{social.name}</title>
                        {social.svg}
                      </svg>
                    </a>
                  ))}
                </div>
              </div>

              <div className="mt-8 p-4 rounded-2xl bg-slate-950 border border-slate-800 font-mono text-xs text-slate-400">
                <span className="text-emerald-400 font-bold">🟢 AVAILABLE FOR SENIOR IT / ARCHITECT ROLES</span>
                <p className="mt-1">Remote Global Tech Firms • FinTech Platforms • Enterprise Microservices</p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}

export default About;
